import LocationFile from "./location-file";


export const locationUploadTypes = {
    file : LocationFile,
}
